const AttributesActionTypes = {
  LIST_SELECTED_ATTRIBUTES: "LIST_SELECTED_ATTRIBUTES",
  CHANGE_ATTRIBUTE_ITEM: "CHANGE_ATTRIBUTE_ITEM",
};

export default AttributesActionTypes;
